export default "/static/sounds/e6688c4ce9990ed89b613956bc4b57e8.mp3";